import { useEffect } from 'react'

export function useUpdateLoginButtonLinks() {
  useEffect(() => {
    const updateLinks = () => {
      const buttons = document.querySelectorAll<HTMLAnchorElement>(
        'a[data-link-type="account-menu-login-button"]',
      )
      const searchParams = new URLSearchParams(window.location.search)

      for (const key of Array.from(searchParams.keys())) {
        if (key.toLowerCase() === 'returnurl') {
          searchParams.delete(key)
        }
      }

      const queryString = searchParams.toString()
      const currentPath
        = window.location.pathname + (queryString ? `?${queryString}` : '')

      buttons.forEach((button) => {
        const originalHref = button.getAttribute('href') || ''

        if (!originalHref.includes('returnUrl=')) {
          const separator = originalHref.includes('?') ? '&' : '?'
          const newHref = `${originalHref}${separator}returnUrl=${encodeURIComponent(currentPath)}`
          button.setAttribute('href', newHref)
        }
      })
    }

    updateLinks()

    const observer = new MutationObserver(updateLinks)

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => observer.disconnect()
  }, [])
}
